var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStrokeUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4999 4.16667C9.11917 4.16667 7.99992 5.28596 7.99992 6.66667C7.99992 8.04738 9.11917 9.16667 10.4999 9.16667C11.8807 9.16667 12.9999 8.04738 12.9999 6.66667C12.9999 5.28596 11.8807 4.16667 10.4999 4.16667ZM6.33325 6.66667C6.33325 4.36548 8.19874 2.5 10.4999 2.5C12.8011 2.5 14.6666 4.36548 14.6666 6.66667C14.6666 8.96785 12.8011 10.8333 10.4999 10.8333C8.19874 10.8333 6.33325 8.96785 6.33325 6.66667ZM3.83325 18.3333C3.83325 14.6514 6.81802 11.6667 10.4999 11.6667C14.1818 11.6667 17.1666 14.6514 17.1666 18.3333C17.1666 18.7936 16.7935 19.1667 16.3333 19.1667C15.873 19.1667 15.4999 18.7936 15.4999 18.3333C15.4999 15.5719 13.2613 13.3333 10.4999 13.3333C7.73849 13.3333 5.49992 15.5719 5.49992 18.3333C5.49992 18.7936 5.12682 19.1667 4.66659 19.1667C4.20635 19.1667 3.83325 18.7936 3.83325 18.3333Z",
    fill: "#B8E6FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStrokeUser);
export default __webpack_public_path__ + "static/media/icon-stroke-user.e04202a52c59886946343fb37818b249.svg";
export { ForwardRef as ReactComponent };